/**
 * Get property layers from the string
 * @param {Map<String, any>} property
 * @param {MainClassProps | null} main
 * @param {String} path
 * @param {StepProps} step
 * @param {String} parent
 * @param {string | boolean | undefined} fn
 * @param {TriggerProps | null} [trigger]
 */
const getLayers = (property, main, path, step, parent, fn, trigger) => {
  if (!main) {
    return [];
  }

  let number = 0;
  const original = property.get("original");
  const isNoneInitial = /^&/.test(original);
  const string = isNoneInitial ? original.slice(1) : original;
  const layers = string.split("╳");
  const result = [];

  property.set("original", string);

  for (const layer of layers) {
    const data = new Map([
      ["data", null],
      ["options", property.get("options")],
      ["trigger", trigger || null],
      ["step", step],
      ["properties", step.get("properties")],
      ["priority", property.get("priority")],
    ]);

    /** @type {StorageItemProps} */
    const map = new Map([
      ["original", layer],
      ["flat", new Set()],
      ["pure", new Map()],
      ["layer", number],
      ["data", data],
      ["path", path],
      ["parent", parent],
      ["fn", fn],
      ["is-none-initial", isNoneInitial],
    ]);

    result.push(map);

    ++number;
  }

  const properties = /** @type {StoragePropertiesProps} */ (
    main.storage.get("properties")
  );

  properties?.push(result);

  return result;
};

export default getLayers;
